import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getAutofillPicksButtonStyles = (theme: Theme) =>
  StyleSheet.create({
    wrap: {
      width: '94%',
      maxWidth: 520,
      alignSelf: 'center',
      marginBottom: 10,
    },
    button: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderRadius: 14,
      backgroundColor: theme.primary,
    },
    buttonPressed: {
      opacity: 0.9,
    },
    buttonHover: {
      opacity: 0.94,
    },
    buttonBusy: {
      opacity: 0.7,
    },
    iconBadge: {
      width: 32,
      height: 32,
      borderRadius: 16,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(255,255,255,0.18)',
    },
    textBlock: {
      flex: 1,
    },
    title: {
      fontSize: 15,
      fontWeight: '800',
      color: theme.onPrimary,
      letterSpacing: -0.2,
    },
    subtitle: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.onPrimary,
      opacity: 0.85,
      marginTop: 1,
    },
  });
